/**
 * Testimonial PropTypes
 *
 * PropType definitions for customer testimonials and reviews
 *
 * @module propTypes/common/testimonial
 */

import PropTypes from "prop-types";

/**
 * Testimonial PropType
 * Customer testimonial shape
 *
 * @property {string} quote - Testimonial quote text (required)
 * @property {string} author_name - Author's name (required)
 * @property {string} country - Author's country (required)
 */
export const TestimonialPropType = PropTypes.shape({
  quote: PropTypes.string.isRequired,
  author_name: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
});
